export const movies = [
  {
    id: 1,
    name: "The Shawshank Redemption",
    yearReleased: 1994,
    rating: 9.3,
    director: "Frank Darabont",
    cast: ["Tim Robbins", "Morgan Freeman", "Bob Gunton"],
    genre: ["Drama"],
    durationMinutes: 142,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/q6y0Go1tsGEsmtFryDOJo3dEmqu.jpg",
    intro: "Two imprisoned men bond over a number of years, finding solace and eventual redemption through acts of common decency."
  },
  {
    id: 2,
    name: "The Godfather",
    yearReleased: 1972,
    rating: 9.2,
    director: "Francis Ford Coppola",
    cast: ["Marlon Brando", "Al Pacino", "James Caan"],
    genre: ["Crime", "Drama"],
    durationMinutes: 175,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/3bhkrj58Vtu7enYsRolD1fZdja1.jpg",
    intro: "The aging patriarch of an organized crime dynasty transfers control of his clandestine empire to his reluctant son."
  },
  {
    id: 3,
    name: "The Dark Knight",
    yearReleased: 2008,
    rating: 9.0,
    director: "Christopher Nolan",
    cast: ["Christian Bale", "Heath Ledger", "Aaron Eckhart"],
    genre: ["Action", "Crime", "Drama"],
    durationMinutes: 152,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/qJ2tW6WMUDux911r6m7haRef0WH.jpg",
    intro: "When the menace known as the Joker wreaks havoc and chaos on the people of Gotham, Batman must accept one of the greatest psychological and physical tests."
  },
  {
    id: 4,
    name: "Pulp Fiction",
    yearReleased: 1994,
    rating: 8.9,
    director: "Quentin Tarantino",
    cast: ["John Travolta", "Uma Thurman", "Samuel L. Jackson"],
    genre: ["Crime", "Drama"],
    durationMinutes: 154,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/d5iIlFn5s0ImszYzBPb8JPIfbXD.jpg",
    intro: "The lives of two mob hitmen, a boxer, a gangster and his wife intertwine in four tales of violence and redemption."
  },
  {
    id: 5,
    name: "Forrest Gump",
    yearReleased: 1994,
    rating: 8.8,
    director: "Robert Zemeckis",
    cast: ["Tom Hanks", "Robin Wright", "Gary Sinise"],
    genre: ["Drama", "Romance"],
    durationMinutes: 142,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/arw2vcBveWOVZr6pxd9XTd1TdQa.jpg",
    intro: "The presidencies of Kennedy and Johnson unfold through the perspective of an Alabama man with an IQ of 75, whose only desire is to be reunited with his childhood sweetheart."
  },
  {
    id: 6,
    name: "Inception",
    yearReleased: 2010,
    rating: 8.8,
    director: "Christopher Nolan",
    cast: ["Leonardo DiCaprio", "Joseph Gordon-Levitt", "Elliot Page"],
    genre: ["Action", "Sci-Fi", "Thriller"],
    durationMinutes: 148,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/9gk7adHYeDvHkCSEqAvQNLV5Uge.jpg",
    intro: "A thief who steals corporate secrets through the use of dream-sharing technology is given the inverse task of planting an idea into the mind of a CEO."
  },
  {
    id: 7,
    name: "The Matrix",
    yearReleased: 1999,
    rating: 8.7,
    director: "Lana Wachowski, Lilly Wachowski",
    cast: ["Keanu Reeves", "Laurence Fishburne", "Carrie-Anne Moss"],
    genre: ["Action", "Sci-Fi"],
    durationMinutes: 136,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/f89U3ADr1oiB1s9GkdPOEpXUk5H.jpg",
    intro: "A computer hacker learns from mysterious rebels about the true nature of his reality and his role in the war against its controllers."
  },
  {
    id: 8,
    name: "Goodfellas",
    yearReleased: 1990,
    rating: 8.7,
    director: "Martin Scorsese",
    cast: ["Robert De Niro", "Ray Liotta", "Joe Pesci"],
    genre: ["Crime", "Drama"],
    durationMinutes: 145,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/aKuFiU82s5ISJpGZp7YkIr3kCUd.jpg",
    intro: "The story of Henry Hill and his life in the mob, covering his relationship with his wife and his partners in crime."
  },
  {
    id: 9,
    name: "Interstellar",
    yearReleased: 2014,
    rating: 8.6,
    director: "Christopher Nolan",
    cast: ["Matthew McConaughey", "Anne Hathaway", "Jessica Chastain"],
    genre: ["Adventure", "Drama", "Sci-Fi"],
    durationMinutes: 169,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/gEU2QniE6E77NI6lCU6MxlNBvIx.jpg",
    intro: "A team of explorers travel through a wormhole in space in an attempt to ensure humanity's survival."
  },
  {
    id: 10,
    name: "Spirited Away",
    yearReleased: 2001,
    rating: 8.6,
    director: "Hayao Miyazaki",
    cast: ["Rumi Hiiragi", "Miyu Irino", "Mari Natsuki"],
    genre: ["Animation", "Adventure", "Family"],
    durationMinutes: 125,
    language: "Japanese",
    posterUrl: "https://image.tmdb.org/t/p/w500/39wmItIWsg5sZMyRUHLkWBcuVCM.jpg",
    intro: "During her family's move to the suburbs, a sullen 10-year-old girl wanders into a world ruled by gods, witches, and spirits where humans are changed into beasts."
  },
  {
    id: 11,
    name: "Parasite",
    yearReleased: 2019,
    rating: 8.5,
    director: "Bong Joon-ho",
    cast: ["Song Kang-ho", "Lee Sun-kyun", "Cho Yeo-jeong"],
    genre: ["Comedy", "Drama", "Thriller"],
    durationMinutes: 132,
    language: "Korean",
    posterUrl: "https://image.tmdb.org/t/p/w500/7IiTTgloJzvGI1TAYymCfbfl3vT.jpg",
    intro: "Greed and class discrimination threaten the newly formed symbiotic relationship between the wealthy Park family and the destitute Kim clan."
  },
  {
    id: 12,
    name: "The Lion King",
    yearReleased: 1994,
    rating: 8.5,
    director: "Roger Allers, Rob Minkoff",
    cast: ["Matthew Broderick", "Jeremy Irons", "James Earl Jones"],
    genre: ["Animation", "Adventure", "Drama"],
    durationMinutes: 88,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/sKCr78MXSLixwmZ8DyJLrpMsd15.jpg",
    intro: "Lion prince Simba and his father are targeted by his bitter uncle, who wants to ascend the throne himself."
  },
  {
    id: 13,
    name: "Gladiator",
    yearReleased: 2000,
    rating: 8.5,
    director: "Ridley Scott",
    cast: ["Russell Crowe", "Joaquin Phoenix", "Connie Nielsen"],
    genre: ["Action", "Adventure", "Drama"],
    durationMinutes: 155,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/ty8TGRuvJLPUmAR1H1nRIsgwvim.jpg",
    intro: "A former Roman General sets out to exact vengeance against the corrupt emperor who murdered his family and sent him into slavery."
  },
  {
    id: 14,
    name: "The Departed",
    yearReleased: 2006,
    rating: 8.5,
    director: "Martin Scorsese",
    cast: ["Leonardo DiCaprio", "Matt Damon", "Jack Nicholson"],
    genre: ["Crime", "Drama", "Thriller"],
    durationMinutes: 151,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/nT97ifVT2J1yMQmeq20Qblg61T.jpg",
    intro: "An undercover cop and a mole in the police attempt to identify each other while infiltrating an Irish gang in South Boston."
  },
  {
    id: 15,
    name: "Whiplash",
    yearReleased: 2014,
    rating: 8.5,
    director: "Damien Chazelle",
    cast: ["Miles Teller", "J.K. Simmons", "Melissa Benoist"],
    genre: ["Drama", "Music"],
    durationMinutes: 106,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/7fn624j5lj3xTme2SgiLCeuedmO.jpg",
    intro: "A promising young drummer enrolls at a cut-throat music conservatory where his dreams of greatness are mentored by an instructor who will stop at nothing."
  },
  {
    id: 16,
    name: "The Prestige",
    yearReleased: 2006,
    rating: 8.5,
    director: "Christopher Nolan",
    cast: ["Christian Bale", "Hugh Jackman", "Scarlett Johansson"],
    genre: ["Drama", "Mystery", "Thriller"],
    durationMinutes: 130,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/tRNlZbgNCNOpLpbPEz5L8G8A0JN.jpg",
    intro: "After a tragic accident, two stage magicians engage in a battle to create the ultimate illusion while sacrificing everything they have to outwit each other."
  },
  {
    id: 17,
    name: "Avengers: Endgame",
    yearReleased: 2019,
    rating: 8.4,
    director: "Anthony Russo, Joe Russo",
    cast: ["Robert Downey Jr.", "Chris Evans", "Mark Ruffalo"],
    genre: ["Action", "Adventure", "Sci-Fi"],
    durationMinutes: 181,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/or06FN3Dka5tukK1e9sl16pB3iy.jpg",
    intro: "After the devastating events of Infinity War, the Avengers assemble once more to reverse Thanos' actions and restore balance to the universe."
  },
  {
    id: 18,
    name: "Spider-Man: Into the Spider-Verse",
    yearReleased: 2018,
    rating: 8.4,
    director: "Bob Persichetti, Peter Ramsey, Rodney Rothman",
    cast: ["Shameik Moore", "Jake Johnson", "Hailee Steinfeld"],
    genre: ["Animation", "Action", "Adventure"],
    durationMinutes: 117,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/iiZZdoQBEYBv6id8su7ImL0oCbD.jpg",
    intro: "Teen Miles Morales becomes the Spider-Man of his universe and must join with five spider-powered individuals from other dimensions to stop a threat."
  },
  {
    id: 19,
    name: "Joker",
    yearReleased: 2019,
    rating: 8.4,
    director: "Todd Phillips",
    cast: ["Joaquin Phoenix", "Robert De Niro", "Zazie Beetz"],
    genre: ["Crime", "Drama", "Thriller"],
    durationMinutes: 122,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/udDclJoHjfjb8Ekgsd4FDteOkCU.jpg",
    intro: "In Gotham City, mentally troubled comedian Arthur Fleck is disregarded and mistreated by society, leading him to embark on a downward spiral of revolution and crime."
  },
  {
    id: 20,
    name: "Coco",
    yearReleased: 2017,
    rating: 8.4,
    director: "Lee Unkrich, Adrian Molina",
    cast: ["Anthony Gonzalez", "Gael García Bernal", "Benjamin Bratt"],
    genre: ["Animation", "Adventure", "Family"],
    durationMinutes: 105,
    language: "English",
    posterUrl: "https://image.tmdb.org/t/p/w500/gGEsBPAijhVUFoiNpgZXqRVWJt2.jpg",
    intro: "Aspiring musician Miguel, confronted with his family's ancestral ban on music, enters the Land of the Dead to find his great-great-grandfather, a legendary singer."
  }
];
